<template>
  <div class="c-filter-bar" v-on="$listeners">
    <filter-bar-search :resource="resource" v-if="showSearch" :action="action" :options="searchOptions"></filter-bar-search>
    <filter-bar-filter
      :resource="resource"
      v-if="showFilter"
      :filter-options="filterOptions"
      :action="action"
      :filter-url-param="filterUrlParam"
    ></filter-bar-filter>
    <filter-bar-sort
      :resource="resource"
      v-if="showSort"
      :sortOptions="sortOptions"
      :action="action"
    ></filter-bar-sort>
    <slot></slot>
  </div>
</template>

<script>
import FilterBarSearch from "./FilterBarSearch";
import FilterBarFilter from "./FilterBarFilter";
import FilterBarSort from "./FilterBarSort";

export default {
  name: "filter-bar",

  props: {
    showSearch: Boolean,
    showFilter: Boolean,
    showSort: Boolean,
    resource: String,
    searchOptions: {
      type: Object,
      default: () => ({isFlat: true})
    },
    action: {
      type: String,
      default: "list"
    },
    filterOptions: Array,
    sortOptions: {
      type: Array,
      default: () => [
        {
          label: "Newest First",
          field: "created_time",
          direction: "desc"
        },
        {
          label: "Oldest First",
          field: "created_time",
          direction: "asc"
        }
      ]
    },
    filterUrlParam: {
      type: String,
      default: null
    }
  },

  components: {
    FilterBarSearch,
    FilterBarFilter,
    FilterBarSort
  }
};
</script>

<style lang="scss">
.c-filter-bar {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  > div {
    border: 1px solid $colour-nhs-pale-grey;
    height: 54px;

    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__label,
  &__control {
    height: 54px;
    display: flex;
    position: relative;
  }

  &__label {
    padding: 2px 0.65em;
    // overflow: hidden;
    min-width: 80px;
    font-size: 16px;
    align-items: center;
    cursor: pointer;
    width: 100%;
    @media screen and (min-width: 768px) {
      width: auto;
    }
  }

  &__control {
    // display: none;
    padding-right: 2em;
    min-width: 100px;
    padding: 2px 0 2px 0.5em;
    margin-left: 0.65em;

    @media screen and (min-width: 768px) {
      border-left: 1px solid $colour-nhs-pale-grey;
    }
  }

  @media screen and (min-width: 1024px) {
    > div {
      border-radius: 2em;
      margin-right: 0.5em;
    }

    &__control {
      display: flex;
    }
  }
}
</style>
